export const colorsChart = [
  '#0a7a50',
  '#941afd',
  '#9f00f2',
  '#0019fe',
  '#affa13',
  '#00e0be',
  '#f51f1f',
  '#0a7a50',
  '#ff867f',
  '#9051ff',
  '#dc25dc',
  '#ffff00',
  '#f51fb5',
  '#1bff14',
  '#2566dc',
];

export const materialsArray = [
  'mate-2050',
  'mate-5629',
  'mate-8482',
  'mate-9472',
  'mate-3809',
  'mate-5099',
  'mate-7221',
  'mate-3563',
  'mate-9452',
  'mate-7839',
  'mate-7320',
  'mate-1617',
  'mate-5601',
  'mate-5896',
  'mate-4652',
];

export const ganttColumns = [
  { type: 'string', label: 'Machine ID' },
  { type: 'string', label: 'Machine Name' },
  { type: 'string', label: 'Recipe' },
  { type: 'date', label: 'Start Date' },
  { type: 'date', label: 'End Date' },
  { type: 'number', label: 'Duration' },
  { type: 'number', label: 'N/A' },
  { type: 'string', label: 'Dependencies' },
];
